import React, { useEffect,useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth'; // Firebase Auth
import { auth } from '../../firebase'; // Assuming firebase is already configured
import { appendToChatHistory, getSubDataForProject} from '../../services/projectService.js'; // New function to append data
import './AIChatPage.css';
import '../../styles/global.css';
import ContentToolbar from '../ContentToolbar.js/ContentToolbar.js';
import { useNavigate } from 'react-router-dom';
import { sendDataToUtility } from '../../services/TTS.js'; // Adjust path based on your project structure
import { useVoiceContext } from '../../VoiceContext.js';
import { FaSortDown,FaChevronDown} from 'react-icons/fa'; // Import the context hook

const V2MODELURL = process.env.REACT_APP_V2_AI_MODEL_URL;

function AIChatPage({ isDarkMode, onLoginClick,setProjectName  }) {
  const location = useLocation();
  const navigate = useNavigate();
  let { itemId } = location.state || {};
  let AImodel1 = 'Canopy v1';
  let AImodel2 = 'Canopy v2';
  const { currentVoiceId } = useVoiceContext();

  const [isToolbarMinimized, setIsToolbarMinimized] = useState(false);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false); // Track auth state
  const [hasProject, setHasProject] = useState(true); // Track if a project exists
  const [currentUserId, setCurrentUserId] = useState(null); // Store the logged-in user ID
  const [chatHistory, setChatHistory] = useState(null); // Store chat history
  const [isVoiceTabActive, setIsVoiceTabActive] = useState(false);
  const [chatHistoryLoaded, setChatHistoryLoaded] = useState(false);
  // Initialize VoiceContext to access currentVoiceId

  // Dropdown state
const [isDropdownOpen, setIsDropdownOpen] = useState(false);
const [chatType, setChatType] = useState(AImodel1); // SET Default chat type
const dropdownRef = useRef(null);


const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

useEffect(() => {
  // Close dropdown if clicked outside
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);

useEffect(() => {
  const iframe = document.getElementById(
    chatType === AImodel1 ? 'voiceflow-iframe' : 'canopy-2-iframe'
  );

  if (iframe && itemId) {
    iframe.contentWindow.postMessage(
      {
        setUserId: itemId,
         // Send both itemId and chatHistory
      },
      '*'
    );

    // Console log for visibility
    //console.log(`Posted setUserId: ${itemId} and chatHistory to iframe with ID: ${iframe.id}`);
    
  }
}, [chatType, itemId, chatHistory]);




const handleChatTypeChange = (type) => {
  setChatType(type);
  setIsDropdownOpen(false);

  // Determine the iframe based on the selected chat type
  const iframe = document.getElementById(
    type === AImodel1 ? 'voiceflow-iframe' : 'canopy-2-iframe'
  );

  if (iframe && itemId) {
    iframe.contentWindow.postMessage(
      {
        setUserId: itemId,
         // Send both itemId and chatHistory
      },
      '*'
    );
    loadChatHistoryIntoSessionKey(itemId);
    //console.log(`Posted chat history to ${iframe.id} iframe:`, chatHistory);
  }
};



const darkModeCSS = 'data:text/css;base64,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'; // Dark mode CSS in base64
const lightModeCSS = 'data:text/css;base64,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'; // Light mode CSS in base64

const transformChatHistory = (chatHistory, userID) => {
  return {
    turns: chatHistory.map((message) => {
      if (message.type === 'user') {
        // For user messages, map the 'message' field directly
        return {
          id: message.id,
          type: 'user',
          timestamp: message.timestamp,
          message: message.message || '', // Safeguard against undefined message
        };
      } else if (message.type === 'system' && Array.isArray(message.messages)) {
        // For system messages, handle both text and image messages
        const systemMessages = message.messages.map((msg) => {
          if (msg.type === 'image' && msg.url) {
            // Treat image as a message with URL
            return {
              type: 'text',  // Keep it as 'text' if needed for widget
              text: [
                {
                  children: [
                    { text: msg.url }  // The image URL will be treated as part of the message
                  ]
                }
              ]
            };
          } else {
            // Handle text messages as usual
            return {
              type: msg.type || 'text',  // Default to 'text' if type is not provided
              text: Array.isArray(msg.text) ? msg.text.map((textObj) => ({
                children: Array.isArray(textObj.children) ? textObj.children.map((child) => ({
                  text: child.text || '',  // Safeguard against undefined text
                })) : []  // If children is undefined, use an empty array
              })) : [],  // If text is undefined, use an empty array
              delay: msg.delay || 0,
              ai: msg.ai || true,  // Assume AI messages if not provided
            };
          }
        });

        return {
          id: message.id,
          type: 'system',
          timestamp: message.timestamp,
          messages: systemMessages,  // Messages array for system with both text and image URLs
        };
      }

      // Fallback for unknown message types
      return {
        id: message.id,
        type: message.type || 'unknown',
        timestamp: message.timestamp,
        messages: [],  // Default to empty messages if unknown type
      };
    }),
    status: 'ACTIVE',
    startTime: chatHistory.length ? chatHistory[0].timestamp : Date.now(),
    userID: userID,
  };
};



const loadChatHistoryIntoSessionKey = async (projectId) => {
  try {
    const data = await getSubDataForProject(projectId);
    if (data) {
      setProjectName(data.projectName || '');

      if (Array.isArray(data.chatHistory) && data.chatHistory.length > 0) {
        const transformedChatHistory = transformChatHistory(data.chatHistory, itemId);
        localStorage.setItem(
          'voiceflow-session-66dac8dbd8e20c0b54aacb62',
          JSON.stringify(transformedChatHistory)
        );
        setChatHistory(transformedChatHistory.turns);

        const canopy2Iframe = document.getElementById('canopy-2-iframe');
        if (canopy2Iframe) {
          canopy2Iframe.contentWindow.postMessage(
            { type: 'setChatHistory', chatHistory: transformedChatHistory.turns },
            '*'
          );
          //console.log('Posted chat history to canopy2 iframe:', transformedChatHistory.turns);
        } else {
          //console.warn('Canopy2 iframe is not available.');
        }
      } else {
        //console.log('No chat history found or project is empty');
        const canopy2Iframe = document.getElementById('canopy-2-iframe');
        if (canopy2Iframe) {
          canopy2Iframe.contentWindow.postMessage(
            { type: 'clearChatHistory' },
            '*'
          );
         //console.log('Posted clearChatHistory to canopy2 iframe');
          
        }
      }
    }
  } catch (error) {
    console.error('Error loading chat history:', error);
  }
};





  // Firebase auth check to get the logged-in user
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsUserLoggedIn(true);
        setCurrentUserId(user.uid); // Set the current user ID
      } else {
        setIsUserLoggedIn(false);
        setCurrentUserId(null); // Reset user ID when logged out
      }
    });
    return () => unsubscribe(); // Cleanup listener on unmount
  }, []);

  // Retrieve the last used project ID for the logged-in user
  useEffect(() => {
    if (currentUserId && !itemId) {
      const lastProjectId = localStorage.getItem(`lastUsedProjectId_${currentUserId}`);
      itemId = lastProjectId || null; // Use last project ID or null if none exists
    }

    if (!itemId) {
      setHasProject(false); // If no project is found, indicate that the user has no project
    } else {
      setHasProject(true); // If itemId exists, set to true
      localStorage.setItem(`lastUsedProjectId_${currentUserId}`, itemId); // Store itemId against the user ID
    }
  }, [itemId, currentUserId]);

  useEffect(() => {
    if (itemId) {
      loadChatHistoryIntoSessionKey(itemId);
    }
  }, [itemId]);

  // Add event listener for chat messages (when receiving session data)
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== window.location.origin) {
        return;
      }
  
      let parsedData;
      try {
        parsedData = JSON.parse(event.data);
      } catch (error) {
        return;
      }
  
      // Log parsed data
      //console.log('Parsed data in parent:', parsedData);
  
      // Handle 'session_saved' type
      if (parsedData && parsedData.type === 'session_saved') {
        //console.log('Session saved event received in parent:', parsedData.message);
  
        const sessionData = JSON.parse(localStorage.getItem('voiceflow-session-66dac8dbd8e20c0b54aacb62'));
  
        if (sessionData && sessionData.turns && sessionData.turns.length > 1) {
          const lastTurn = sessionData.turns[sessionData.turns.length - 1];
          const secondLastTurn = sessionData.turns[sessionData.turns.length - 2];
  
          appendToChatHistory(itemId, secondLastTurn);
          appendToChatHistory(itemId, lastTurn);
          //console.log('Appended last two turns to chat history:', lastTurn, secondLastTurn);
  
          // Check if the voice tab is active and send data to TTS.js function
          //console.log('Current state of isVoiceTabActive:', isVoiceTabActive); // Log the state
  
          if (isVoiceTabActive) {
            const messageLog = `Voice tab is active and session was saved! Last message: ${lastTurn.message || 'No message found'}`;
            //console.log(messageLog);
            //console.log('Sending data with voice ID:', currentVoiceId);
  
            // Call the new utility function with the logged message
            sendDataToUtility(messageLog, sessionData, currentVoiceId);
          } else {
            //console.log('Voice tab is not active. Skipping TTS function call.');
          }
        }
      }
    };
  
    window.addEventListener('message', handleMessage);
  
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [itemId, isVoiceTabActive, currentVoiceId]);
  

  window.addEventListener("message", async (event) => {
    // Check that the message is of the correct type and includes the necessary data
    if (event.data.type === "newMessage") {
      const { turn, userId: messageUserId } = event.data;
  
      // Verify that the message's userId matches the active user's ID
      if (messageUserId !== itemId) {
        //console.log(`Ignoring message: userId ${messageUserId} does not match current user ${currentUserId}`);
        return;
      }
  
      try {
        if (turn.type === "user") {
          //console.log("Received user message from iframe:", turn.message);
          await appendToChatHistory(itemId, turn); // Append the user message to the specified project
          //console.log("User message appended to chat history for project:", itemId);
        } else if (turn.type === "system") {
          //console.log("Received bot message from iframe:", turn.messages[0].text[0].children[0].text);
          await appendToChatHistory(itemId, turn); // Append the bot message to the specified project
         // console.log("Bot message appended to chat history for project:", itemId);
        }
      } catch (error) {
        console.error("Error appending to chat history:", error);
      }
    }
  });
  
   


  
  // Load the Voiceflow chat widget with chat history (if available)
  useEffect(() => {
    if (isUserLoggedIn && itemId) {
      const iframe = document.getElementById('voiceflow-iframe');
      if (iframe) {
        iframe.src = 'about:blank'; // Reset iframe
  
        setTimeout(() => {
          const iframeDoc = iframe.contentWindow.document;
          const currentCSS = isDarkMode ? darkModeCSS : lightModeCSS;
  
          iframeDoc.open();
          iframeDoc.write(`
            <style>
              @import url("${currentCSS}");
            </style>
            <script type="text/javascript">
              (function(d, t) {
                var v = d.createElement(t), s = d.getElementsByTagName(t)[0];
                v.onload = function() {
                  window.voiceflow.chat.load({
                    verify: { projectID: '66dac8dbd8e20c0b54aacb62' },
                    url: 'https://general-runtime.voiceflow.com',
                    versionID: 'production',
                    userID: '${itemId}',
                    session: ${chatHistory ? JSON.stringify(chatHistory) : 'null'}, 
                    assistant: { stylesheet: "${currentCSS}" }
                  }).then(() => {
                    setTimeout(() => window.voiceflow.chat.open(), 500);
                  });
  
                  // Listen for Voiceflow events inside the iframe
                  window.addEventListener('message', (event) => {
                    //console.log('Message event received in iframe:', event);
  
                    // Check if event data is a string and parse it if necessary
                    let eventData = event.data;
                    if (typeof event.data === 'string') {
                      try {
                        eventData = JSON.parse(event.data);
                      } catch (error) {
                        //console.error('Error parsing event data:', error);
                        return; // Skip processing if parsing fails
                      }
                    }
  
                    //console.log('Parsed event data:', eventData);
  
                    // Always check the origin for security
                    if (event.origin !== window.location.origin) {
                      console.warn('Ignoring message from untrusted origin:', event.origin);
                      return;
                    }
  
                    // Ensure eventData is an object and has a type property
                    if (eventData && eventData.type) {
                      switch (eventData.type) {
                        case 'voiceflow:save_session':
                          //console.log('Save session event detected in iframe:', eventData);
                          window.parent.postMessage(
                            JSON.stringify({
                              type: 'session_saved',
                              message: 'Save session event occurred',
                              payload: eventData.payload,
                            }),
                            window.location.origin
                          );
                          //console.log('Post message from iframe to parent: Save session event occurred');
                          break;
  
                        case 'imageUrl':
                          const imageUrl = eventData.imageUrl;
                          //console.log('Received imageUrl event:', imageUrl);
                          window.voiceflow.chat.interact({
                            type: "intent",
                            payload: {
                              intent: { name: "/vision" },
                              query: '/vision ' + imageUrl,
                              variables: {}
                            }
                          }).then(response => {
                            //console.log('Interact response:', response);
                          }).catch(error => {
                            //console.error('Error interacting with Voiceflow:', error);
                          });
                          break;
  
                        case 'requestIntent':
                          const request = eventData.request;
                          //console.log('Received requestIntent event:', request);
                          window.voiceflow.chat.interact({
                            type: "intent",
                            payload: {
                              intent: { name: "/request" },
                              query: request,
                              variables: {}
                            }
                          }).then(response => {
                            //console.log('Request interact response:', response);
                          }).catch(error => {
                            //console.error('Error interacting with Voiceflow:', error);
                          });
                          break;
  
                        default:
                          //console.log('Unknown event type:', eventData.type);
                      }
                    } else {
                      console.warn('Event data is missing the type property:', eventData);
                    }
                  }, false);
                };
                v.src = "https://cdn.voiceflow.com/widget/bundle.mjs";
                v.type = "text/javascript";
                s.parentNode.insertBefore(v, s);
              })(document, 'script');
            </script>
          `);
  
          iframeDoc.close();
        }, 100);
      }
    }
  }, [itemId, isDarkMode, isUserLoggedIn, chatHistory]);
  
  
  
  

  return (
    <div className="main-content" style={{ paddingRight: isToolbarMinimized ? '70px' : '220px' }}>
    <div className="content-area">
      {/* Chat Type Toggle Dropdown */}
      <div className="chat-type-dropdown-container" ref={dropdownRef}>
        <button onClick={toggleDropdown} className="chat-type-toggle-button">
          {chatType} <FaChevronDown className="chevron-icon" />
        </button>
        {isDropdownOpen && (
          <div className="chat-type-dropdown-menu">
            <div onClick={() => handleChatTypeChange(AImodel1)} className="chat-type-dropdown-item">
              {AImodel1}
            </div>
            <div onClick={() => handleChatTypeChange(AImodel2)} className="chat-type-dropdown-item">
              {AImodel2}
            </div>
          </div>
        )}
      </div>

        {/* Conditionally Render Iframes Based on Chat Type */}
        {isUserLoggedIn ? (
          hasProject ? (
            <>
              <iframe
                id="voiceflow-iframe"
                className="voiceflow-chat-container"
                src="about:blank"
                width="110%"
                height="200%"
                style={{
                  border: 'none',
                  borderRadius: '10px',
                  display: chatType === AImodel1 ? 'block' : 'none',
                }}
                title="Canopy Legacy Chat"
              ></iframe>

              <iframe
                id="canopy-2-iframe"
                className="voiceflow-chat-container"
                src= {V2MODELURL}
                width="110%"
                height="200%"
                style={{
                  border: 'none',
                  borderRadius: '10px',
                  display: chatType === AImodel2 ? 'block' : 'none',
                }}
                title="Canopy 2.0 Chat"
                allow="clipboard-write; clipboard-read;"
              ></iframe>
            </>
          ) : (
            <div className="no-project-message">
              <p>No project found. Please create or select a project to start chatting.</p>
              <div className="create-project-link">
                <a href="#" onClick={() => navigate('/projects')}>Go to My Projects</a>
              </div>
            </div>
          )
        ) : (
          <div className="login-prompt">
            <p>Please log in to use the AI chat feature.</p>
            <div className="login-link">
              <a href="#" onClick={onLoginClick}>Log in now</a>
            </div>
          </div>
        )}
      </div>
      <ContentToolbar
        onMinimize={setIsToolbarMinimized}
        currentProjectId={itemId}
        setIsVoiceTabActive={setIsVoiceTabActive}
        canopy2Active={chatType === AImodel2} // Add this prop
      />
    </div>
  );
}

export default AIChatPage;
